import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TopBarWidgetComponent } from '@app/_layout/top-bar/top-bar-widget/top-bar-widget.component';

@Component({
  selector: 'app-main-iframe-layout',
  standalone: true,
  imports: [TopBarWidgetComponent, RouterOutlet],
  templateUrl: './main-iframe-layout.component.html'
})
export class MainIframeLayoutComponent {}
